import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type HomeState = {
  isDataAvailable: boolean;
  isData: string;
  activeMenuTitle: string
};

const initialState: HomeState = {
  isDataAvailable: false,
  isData: '',
  activeMenuTitle: ''
};

export const isDataAvailableReducers = createSlice({
  name: 'homeAvailable',
  initialState,
  reducers: {
    setIsDataAvailable: (state, action: PayloadAction<boolean>) => {
      state.isDataAvailable = action.payload;
      console.log(action.payload);
    },
    setIsData: (state, action: PayloadAction<string>) => {
      state.isData = action.payload;
    },
    setActiveMenuTitle: (state, action: PayloadAction<string>) => {
      state.activeMenuTitle = action.payload;
    },
  },
});

export const { setIsDataAvailable, setIsData, setActiveMenuTitle } = isDataAvailableReducers.actions;
export const selectIsData = (state: { homeAvailable: HomeState }) => state.homeAvailable?.isData;
export const selectIsDataAvailable = (state: { homeAvailable: HomeState }) => state.homeAvailable?.isDataAvailable;
export const selectActiveMenuTitle = (state: { homeAvailable: HomeState }) => state.homeAvailable?.activeMenuTitle;

export default isDataAvailableReducers;
